<template>
  <div>
    <div class="bg" style="padding-bottom: 20px">
      <FxedTop ref="fxedTop"></FxedTop>
    </div>
    <div class="page">
      <div class="pageTitle">
        <div class="sort"></div>
        <div class="currentLocation">当前位置：首页 > 课程小节详情</div>
      </div>
      <div class="container">
        <img class="literature" :src="typeConfig.content_img" mode="widthFix" />
        <div class="saveImageRow" v-if="loading">
          <div class="svaeImg" @click="handleSaveCallback">
            点击按钮完成学习
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { sectionInfo, sectionComplete } from "@/api/wkApi.js";
import FxedTop from "@/components/FxedTop";
import Footer from "@/components/Footer";
export default {
  components: {
    FxedTop,
    Footer,
  },
  data() {
    return {
      typeConfig: {},
      loading: false,
    };
  },
  created() {
    this.options = this.$route.query;
    // 获取第一节课内容
    sectionInfo(this.options).then((res) => {
      this.typeConfig = res.result.typeConfig;
      this.loading = true;
    });
  },
  methods: {
    handleSaveCallback() {
      const { options } = this;
      sectionComplete(options).then((data) => {
        this.$message.success("学习已完成");
      });
    },
  },
};
</script>

<style>
.literature {
  width: 100%;
}
.saveImageRow {
  margin: 20px 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.svaeImg {
  height: 80px;
  width: 340px;
  line-height: 80px;
  color: #fff;
  font-size: 34px;
  text-align: center;
  background-color: #549cb1;
  border-radius: 10px;
  margin-bottom: 20px;
}
</style>
